<template>
  <Dialog
    :visible="modelValue"
    header="Подтверждение удаления"
    :modal="true"
    :closable="!loading"
    :close-on-escape="!loading"
    :style="{ width: '450px' }"
    @update:visible="handleClose"
  >
    <div class="text-center">
      <i class="pi pi-exclamation-triangle text-5xl text-orange-500 mb-3" />
      <p class="mb-2">{{ message }}</p>
      <p v-if="itemTitle" class="text-sm text-gray-500">{{ itemTitle }}</p>
    </div>

    <template #footer>
      <Button label="Отмена" severity="secondary" :disabled="loading" @click="handleClose" />
      <Button
        label="Удалить"
        severity="danger"
        @click="handleConfirm"
        :loading="loading"
        :disabled="loading"
      />
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

const props = defineProps({
  loading: { type: Boolean, default: false },
  modelValue: { type: Boolean, default: false },
  itemTitle: { type: String, default: null },
  message: { type: String, default: "Вы уверены, что хотите удалить этот элемент?" }
});

const emit = defineEmits(["update:modelValue", "confirm"]);

function handleClose() {
  if (props.loading) return;
  emit("update:modelValue", false);
}

function handleConfirm() {
  if (props.loading) return;
  emit("confirm");
}
</script>
